export const URLBase = {
    TEST: "https://marketing-chamber.k8s.dev.wyborcza.pl/",
    PROD: "/"
};
export const RequestPaths = {
    TEMPLATE: {
        TEST: "match-template",
        PROD: "marketing-chamber/match-template",
    },
    AGREEMENT: "marketing-proxy/agreement"
};
export const SquidURLs = {
    https: "https://squid.gazeta.pl",
    http: "http://squid.gazeta.pl"
};
